// Ajuste este prefixo se a subpasta da hospedagem mudar.
// Como o React e a API vivem no mesmo domínio/subpasta, "credentials: include"
// garante que o cookie de sessão do PHP (PHPSESSID) é enviado em toda requisição.
const API_BASE = "/api";

/**
 * Faz uma chamada à API PHP e já devolve o JSON parseado.
 * @param {string} endpoint - ex: "login.php"
 * @param {RequestInit} options - mesmas opções do fetch (method, body, etc.)
 */
export async function apiFetch(endpoint, options = {}) {
  const res = await fetch(`${API_BASE}/${endpoint}`, {
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
    ...options,
  });

  // Mesmo em erros HTTP (401, 405, 500), a API sempre responde JSON
  // no formato { ok: true/false, ... }, então tentamos parsear de qualquer forma.
  let data;
  try {
    data = await res.json();
  } catch {
    data = { ok: false, erro: "Resposta inválida do servidor." };
  }

  return data;
}